import { render, staticRenderFns } from "./PendingApproval.vue?vue&type=template&id=a892f9a0"
import script from "./PendingApproval.vue?vue&type=script&lang=js"
export * from "./PendingApproval.vue?vue&type=script&lang=js"
import style0 from "./PendingApproval.vue?vue&type=style&index=0&id=a892f9a0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports